// Copyright The OpenTelemetry Authors
// SPDX-License-Identifier: Apache-2.0

import AnnouncementBar from '../AnnouncementBar';
import BackToTop from '../BackToTop';
import Header from '../Header';
import { ChatBot } from '../ChatBot';

interface IProps {
  children: React.ReactNode;
}

const Layout: React.FC<IProps> = ({ children }) => {
  return (
    <>
      <AnnouncementBar />
      <Header />
      <main>{children}</main>
      <ChatBot />
      <BackToTop />
    </>
  );
};

export default Layout;
